var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-icon', _vm._g(_vm._b({
          attrs: {
            "color": "gray"
          }
        }, 'v-icon', attrs, false), on), [_vm._v("mdi-alert-circle")])];
      }
    }])
  }, [_c('span', [_vm._v(_vm._s(_vm.message))])]);

}
var staticRenderFns = []

export { render, staticRenderFns }